@if (mzTabResult) {
  <div class="w-full mt-3">
    <p-panel header="Lipid Filters" [toggleable]="true" [collapsed]="true">
      <app-dataset-lipid-filters></app-dataset-lipid-filters>
    </p-panel>
  </div>
  @if (filterActive) {
    <p-message severity="info" icon="pi pi-filter" class="w-12 mt-3"
      text="Filter active — donuts, range plots, sunbursts and the boxplot show a filtered subset of lipid species."
    ></p-message>
  }

  <app-responsive-tabs
    #tabs="appResponsiveTabs"
    [tabs]="responsiveTabs"
    [activeTab]="selectedTabIndex"
    (activeTabChange)="onTabChange($event)"
    [lazy]="true"
    [cache]="true"
    [tooltips]="true"
    class="block mt-3">
  </app-responsive-tabs>

  <div class="tab-content">
    @if (tabs.shouldRender(0)) {
      <div [hidden]="!tabs.isVisible(0)" class="tab-panel" id="category-class-level">
        <!-- 2x2 grid: row 1 = category-count donut + class-level ranges,
             row 2 = category-concentration donut + species-level ranges.
             CSS Grid (not two independently-stacked flex columns) so each
             donut's row height matches its paired range plot's row height —
             the range plots are much taller, so stacking them in separate
             columns left the second donut nowhere near its counterpart. -->
        <div class="donut-range-grid">
          <div class="donut-range-cell">
            <app-dataset-plot-donut [datasetIds]="[mzTabResult?.id]" [lipidLevel]="categoryLipidLevel"
              [plotLayout]="lipidCategoryCompositionPlotLayout" [counts]="true" [showDatasetTitle]="false"
              [plotHeightPxOverride]="'400px'" [selectedCategories]="selectedCategories">
            </app-dataset-plot-donut>
          </div>
          <div class="donut-range-cell align-content-center">
            @if (loadingLipidClassCompositionPlotData) {
              <p-progress-spinner class="flex w-full custom-spinner" ariaLabel="loading" strokeWidth="4"
              [ngStyle]="{ position: 'relative' }"></p-progress-spinner>
            }
            @if (!loadingLipidClassCompositionPlotData) {
              <plotly-plot [data]="lipidClassCompositionPlotData" [layout]="lipidClassRangesPlotLayout"
                [useResizeHandler]="true" [config]="lipidClassRangesPlotConfig"
                [style]="{ position: 'relative', width: '100%', height: '100%' }">
              </plotly-plot>
            }
          </div>
          <div class="donut-range-cell">
            <app-dataset-plot-donut [datasetIds]="[mzTabResult?.id]" [lipidLevel]="categoryLipidLevel"
              [plotLayout]="lipidCategoryConcentrationPlotLayout" [counts]="false" [showDatasetTitle]="false"
              [plotHeightPxOverride]="'400px'" [selectedCategories]="selectedCategories">
            </app-dataset-plot-donut>
          </div>
          <div class="donut-range-cell align-content-center">
            @if (loadingLipidSpeciesCompositionPlotData) {
              <p-progress-spinner class="flex w-full custom-spinner" ariaLabel="loading" strokeWidth="4"
              [ngStyle]="{ position: 'relative' }"></p-progress-spinner>
            }
            @if (!loadingLipidSpeciesCompositionPlotData) {
              <plotly-plot [data]="lipidSpeciesCompositionPlotData" [layout]="lipidSpeciesRangesPlotLayout"
                [useResizeHandler]="true" [config]="lipidSpeciesRangesPlotConfig"
                [style]="{ position: 'relative', width: '100%', height: '100%' }">
              </plotly-plot>
            }
          </div>
        </div>
      </div>
    }

    @if (tabs.shouldRender(1)) {
      <div [hidden]="!tabs.isVisible(1)" class="tab-panel" id="species-level-sunburst">
        <!-- Sunburst row: two half-width columns -->
        <div class="flex flex-row flex-wrap">
          <div class="w-full lg:w-6 xl:w-6 align-content-center">
            @if (loadingLipidSpeciesSunburstCountPlotData) {
              <p-progress-spinner class="flex w-full custom-spinner" ariaLabel="loading" strokeWidth="4"
              [ngStyle]="{ position: 'relative' }"></p-progress-spinner>
            }
            @if (!loadingLipidSpeciesSunburstCountPlotData) {
              <plotly-plot [data]="lipidSpeciesSunburstCountPlotData" [layout]="lipidLevelCompositionSunburstCountPlotLayout"
                [useResizeHandler]="true" [config]="homePlotlyConfig"
                [style]="{ position: 'relative', width: '100%', height: '100%' }">
              </plotly-plot>
            }
          </div>
          <div class="w-full lg:w-6 xl:w-6 align-content-center">
            @if (loadingLipidSpeciesSunburstConcentrationPlotData) {
              <p-progress-spinner class="flex w-full custom-spinner" ariaLabel="loading" strokeWidth="4"
              [ngStyle]="{ position: 'relative' }"></p-progress-spinner>
            }
            @if (!loadingLipidSpeciesSunburstConcentrationPlotData) {
              <plotly-plot [data]="lipidSpeciesSunburstConcentrationPlotData" [layout]="lipidLevelCompositionSunburstConcentrationPlotLayout"
                [useResizeHandler]="true" [config]="homePlotlyConfig"
                [style]="{ position: 'relative', width: '100%', height: '100%' }">
              </plotly-plot>
            }
          </div>
        </div>
      </div>
    }

    @if (tabs.shouldRender(2)) {
      <div [hidden]="!tabs.isVisible(2)" class="tab-panel" id="species-level-boxplot">
        <div class="w-full flex flex-grow-1 flex-row flex-wrap justify-content-center align-content-center p-3 boxplot-plot-title">Lipid Quantity Ranges Across Sample Measurements on Species Level</div>
        <div class="w-full flex flex-grow-1 flex-row flex-wrap align-content-center">
          @if (!quantificationUnit) {
            <p-progress-spinner class="flex w-full custom-spinner" ariaLabel="loading" strokeWidth="4"
            [ngStyle]="{ position: 'relative' }"></p-progress-spinner>
          }
          @if (quantificationUnit) {
            <app-dataset-plot-boxplot
              [datasetIds]="datasetIds"
              [lipidLevel]="speciesLipidLevel"
              [quantificationUnit]="quantificationUnit"
              [datasetIdsToLabels]="datasetIdsToLabels"
              [showTable]="false"
              class="flex w-full" />
          }
        </div>
      </div>
    }

    @if (tabs.shouldRender(3)) {
      <div [hidden]="!tabs.isVisible(3)" class="tab-panel" id="atlas">
        <app-atlas-fit-tab [datasets]="atlasDatasets" [autoFit]="true"></app-atlas-fit-tab>
      </div>
    }
  </div>
}
